import { z } from 'zod';
import { uuidSchema } from './validation.js';
/**
 * AS Colour account (BLU-1501). Inputs only: the organisation and the user come
 * from auth. The login fields are named `loginEmail` and `password` because the
 * Sentry scrub redacts those keys, so a request body on an event never carries
 * either. The password is never trimmed or otherwise changed: it goes to AS Colour
 * exactly as typed.
 */
export const supplierTradeConnectSchema = z.object({
    loginEmail: z.string().trim().min(1).max(320),
    password: z.string().min(1).max(512),
});
const deliverToField = z.string().trim().max(200).nullable().optional();
/** Where a floor's order goes. Nothing is required until AS Colour's order reply says what it needs. */
export const supplierTradeDeliverToSchema = z.object({
    name: deliverToField,
    address1: deliverToField,
    address2: deliverToField,
    city: deliverToField,
    state: deliverToField,
    postcode: deliverToField,
    country: deliverToField,
    phone: deliverToField,
    email: deliverToField,
});
/** A patch of one floor: a key left out stays as it is. */
export const supplierTradeSaveFloorSchema = z
    .object({
    locationId: uuidSchema,
    shippingMethod: z.string().trim().min(1).max(100).optional(),
    deliverTo: supplierTradeDeliverToSchema.optional(),
})
    .refine((input) => input.shippingMethod !== undefined || input.deliverTo !== undefined, {
    message: 'Nothing to save',
});
export const supplierTradeSetFillPoPricesSchema = z.object({ enabled: z.boolean() });
export const supplierTradeSetOrderingEnabledSchema = z.object({ enabled: z.boolean() });
